import {
  Button,
  Text,
  tokens,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Input,
  Spinner,
} from '@fluentui/react-components';
import type { PasswordDialogProps } from './types';

export default function PasswordDialog({
  open,
  onOpenChange,
  passwordPdfInfo,
  pdfPassword,
  setPdfPassword,
  passwordRetrying,
  passwordError,
  handlePasswordRetry,
  setPasswordPdfInfo,
  setPasswordError,
}: PasswordDialogProps) {
  const handleClose = () => {
    onOpenChange(false);
    setPasswordPdfInfo(null);
    setPdfPassword('');
    setPasswordError(null);
  };

  return (
    <Dialog open={open} onOpenChange={(_, data) => {
      if (!data.open) handleClose();
    }}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Password Required</DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Text>
                This PDF is password protected. Drake Proformas typically use the
                <strong> last 4 digits of the primary taxpayer's SSN</strong> as the password.
              </Text>
              {passwordPdfInfo && (
                <div style={{ padding: '12px', backgroundColor: tokens.colorNeutralBackground3, borderRadius: '4px' }}>
                  <Text size={200} weight="semibold">File:</Text>{' '}
                  <Text size={200}>{passwordPdfInfo.originalFileName}</Text>
                </div>
              )}
              <Input
                type="password"
                placeholder="Enter password (e.g., 1234)"
                value={pdfPassword}
                onChange={(_, data) => setPdfPassword(data.value)}
                maxLength={10}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && pdfPassword.length >= 4) {
                    handlePasswordRetry();
                  }
                }}
              />
              {passwordError && (
                <div style={{ padding: '12px', backgroundColor: '#fde7e9', borderRadius: '4px', color: '#a4262c' }}>
                  {passwordError}
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              appearance="primary"
              onClick={handlePasswordRetry}
              disabled={passwordRetrying || pdfPassword.length < 4}
            >
              {passwordRetrying ? (
                <>
                  <Spinner size="tiny" style={{ marginRight: '8px' }} />
                  Extracting...
                </>
              ) : (
                'Unlock & Extract'
              )}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
